import HomologBrowser from './HomologBrowser';

export default HomologBrowser;
